<template>
  <v-container>
    <v-card outlined>
      <v-card-title>
        Cruscotto dati manifestazione
      </v-card-title>
      <v-card-text v-if="aggregatedData">
        <div v-if="aggregatedData">
          <h3>Mensa</h3>
          <ul>
            <li><strong>Costo totale buoni:</strong> {{ aggregatedData.total_vouchers_cost }} €</li>
            <li><strong>Incasso totale buoni:</strong> {{ aggregatedData.total_vouchers_income }} €</li>
            <!-- Display grouped vouchers data -->
            <li> <strong>Statistiche occupazione mensa per giorno e pasto (capienza 120 posti):</strong>
              <ul v-for="(meals, date) in aggregatedData.grouped_vouchers_data" :key="date">
                <li>{{ formatDate(date) }}
                <div v-for="(total, meal) in meals" :key="meal">
                  {{ meal }}: {{ total }}
                </div></li>
              </ul>
            </li>
          </ul>
          <br><hr><br>
          <h3>Trasporti</h3>
          <ul>
            <li>Costo totale trasporti: {{ aggregatedData.total_transports_cost }} €</li>
            <!-- Display grouped transports data -->
            <li> <strong>Statistiche trasporti per stato e mezzo utilizzato:</strong>
              <ul v-for="(statuses, kind) in aggregatedData.grouped_transports_data" :key="kind">
                <li>{{ kind }}
                  <div v-for="(total, status) in statuses" :key="status">
                    {{ status }}: {{ total }} €
                  </div>
                </li>
              </ul>
            </li>
          </ul>
          <br><hr><br>
          <h3>Camere</h3>
          <ul>
            <li><strong>Costo totale camere:</strong> {{ aggregatedData.total_room_cost }} €</li>
            <!-- Display grouped room costs data -->
            <li> <strong>Costi camere per hotel:</strong>
              <ul v-for="(total, hotel) in aggregatedData.grouped_room_costs_data" :key="hotel">
                <li>{{ hotel }}: {{ total }} €</li>
              </ul>
            </li>
          </ul>
        </div>
        <div v-else>
          <p>Loading...</p>
        </div>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  computed: {
    aggregatedData() {
      return this.$store.state.aggregatedData.aggregatedData;
    },
    showId() {
      return this.$route.params.id;
    },
  },
  mounted() {
    this.$store.dispatch('fetchAggregatedData', { params: { showId: this.showId } });
  },
  methods: {
    formatDate(date) {
      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    }
  }
};
</script>